// extracted by mini-css-extract-plugin
export default {"tppHeader":"Accesses_tppHeader__RS5Sb"};